import axios from "axios";

export const CreateEmployeeAttendance = async (attendanceData) => {
  try {
    const response = await axios.post(
      `/employee-attendance`,
      {
        user: attendanceData.user,
        clockIn: attendanceData.clockIn,
        status: attendanceData.status,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create employee attendance:", error.message);
    throw error;
  }
};

export const getEmployeeAttendance = async (params = {}) => {
  try {
    const response = await axios.get(
      `/employee-attendance`,
      { params });
    return response.data;
  } catch (error) {
    console.error("Failed fetching employee attendance:", error.message);
    throw error;
  }
};

export const updateEmployeeAttendance = async (
  userId,
  date,
  attendanceData
) => {
  try {
    const response = await axios.put(
      `/employee-attendance/${userId}/${date}`,
      {
        clockOut: attendanceData.clockOut,
        totalHours: attendanceData.totalHours,
        status: attendanceData.status,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed updating employee attendance:", error.message);
    throw error;
  }
};

// employeeAllocationApiService.js
export const getEmployeeAttendanceCounts = async (userId, startDate, endDate) => {
  try {
    const response = await axios.get(
      `/employee-attendance/attendance-counts`,
      {
        params: {
          user_Id: userId,
          startDate: startDate,
          endDate: endDate
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch attendance counts:", error.message);
    throw error;
  }
};

// Manual attendance
export const manualAttendance = async (data) => {
  try {
    const response = await axios.post('/employee-attendance/manual-attendance', data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get today's attendance status
export const getTodayAttendanceStatus = async (userId) => {
  try {
    const response = await axios.get(`/employee-attendance/today-status?userId=${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};


export const getEmployeeCurrentMonthLeaveDetails = async (userId) => {
  try {
    const response = await axios.get(
      `/dashboard/leave-summary/${userId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching employee current month leave details:", error);
    throw error;
  }
};

// Fetch employee monthly summary (attendance, leaves, and balances)
export const getEmployeeMonthlySummary = async (userId) => {
  try {
    const response = await axios.get(
      `/dashboard/leave-summary/details/${userId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching employee monthly summary:", error);
    throw error;
  }
};

